import { render } from "./drawerHeader.vue?vue&type=template&id=2d56d3cf"
import script from "./drawerHeader.vue?vue&type=script&lang=js"
export * from "./drawerHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__